/* eslint-disable */

import {
  Flex,
  Box,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  Link,
  useColorModeValue,
  useToast
} from '@chakra-ui/react';
import * as React from 'react';

import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getSortedRowModel,
  useReactTable,
} from '@tanstack/react-table';
import ReactPaginate from 'react-paginate'

// Custom components
import Card from 'components/card/Card';
import Menu from 'components/menu/MainMenu';
import request from '@/http/request'
import { commonFetch } from '@/utils/util'

const columnHelper = createColumnHelper();

// const columns = columnsDataCheck;
export default function ColumnTable(props) {
  const { tableData, onDetail } = props;
  const toast = useToast();
  const [sorting, setSorting] = React.useState([]);
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  let defaultData = [];
  const columns = [
    columnHelper.accessor('createdAt', {
      id: 'createdAt',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          充值时间
        </Text>
      ),
      cell: (info) => (
        <Text color={textColor} fontSize="sm" fontWeight="700">
          {info.row.original.createdAt}
        </Text>
      ),
    }),
    columnHelper.accessor('changeBalance', {
      id: 'changeBalance',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          充值额度
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text color={textColor} fontSize="sm" fontWeight="700">
            ¥{info.row.original.changeBalance}
          </Text>
        </Flex>
      ),
    }),
    columnHelper.accessor('actualChangeBalance', {
      id: 'actualChangeBalance',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          支付金额
        </Text>
      ),
      cell: (info) => (
        <Flex align="center">
          <Text color={textColor} fontSize="sm" fontWeight="700">
            ¥{info.row.original.actualChangeBalance}
          </Text>
        </Flex>
      ),
    }),
    // columnHelper.accessor('progress', {
    //   id: 'progress',
    //   header: () => (
    //     <Text
    //       justifyContent="space-between"
    //       align="center"
    //       fontSize={{ sm: '10px', lg: '12px' }}
    //       color="gray.400"
    //     >
    //       手续费
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Text color={textColor} fontSize="sm" fontWeight="700">
    //       ¥ 0.00
    //     </Text>
    //   ),
    // }),
    columnHelper.accessor('quantity', {
      id: 'quantity',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          订单号
        </Text>
      ),
      cell: (info) => {
        // console.log(info, 'info')
        return (
          <Flex direction={'column'}>
            <Flex align={'center'} mb="5px">
              {/* <Box bg="brand.200" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
                <Text color={'#fff'} fontSize="sm" fontWeight="700">
                  支付
                </Text>
              </Box> */}
              <Text color={'gray.500'}>{info.row.original.mchOrderNo}</Text>
            </Flex>
            {/* <Flex align={'center'}>
              <Box bg="green.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
                <Text color={'#fff'} fontSize="sm" fontWeight="700">
                  商户
                </Text>
              </Box>
              <Text color={'gray.500'}>{info.row.original.mchNo}</Text>
            </Flex> */}
          </Flex>
        )
      }
    }),
    // columnHelper.accessor('date', {
    //   id: 'date3',
    //   header: () => (
    //     <Text
    //       justifyContent="space-between"
    //       align="center"
    //       fontSize={{ sm: '10px', lg: '12px' }}
    //       color="gray.400"
    //     >
    //       支付方式
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Text color={textColor} fontSize="sm" fontWeight="700">
    //       微信支付
    //     </Text>
    //   ),
    // }),
    columnHelper.accessor('date', {
      id: 'date2',
      header: () => (
        <Text
          justifyContent="space-between"
          align="center"
          fontSize={{ sm: '10px', lg: '12px' }}
          color="gray.400"
        >
          状态
        </Text>
      ),
      cell: (info) => (
        <Flex>
          {info.row.original.state === 1 ? (
            <Box bg="orange.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
              <Text color={'#fff'} fontSize="sm" fontWeight="700">
                支付中
              </Text>
            </Box>
          ) : null}
          {info.row.original.state === 2 ? (
            <Box bg="green.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
              <Text color={'#fff'} fontSize="sm" fontWeight="700">
                成功
              </Text>
            </Box>
          ) : null}
          {info.row.original.state === 3 ? (
            <Box bg="orange.500" textAlign={'center'} padding={'4px 6px'} borderRadius={'4px'} mr="4px">
              <Text color={'#fff'} fontSize="sm" fontWeight="700">
                已取消
              </Text>
            </Box>
          ) : null}
        </Flex>
      ),
    }),
    // columnHelper.accessor('date', {
    //   id: 'date0',
    //   header: () => (
    //     <Text
    //       justifyContent="space-between"
    //       align="center"
    //       fontSize={{ sm: '10px', lg: '12px' }}
    //       color="gray.400"
    //     >
    //       操作
    //     </Text>
    //   ),
    //   cell: (info) => (
    //     <Link color="brand.500" onClick={() => onDetail(info.row.original)}>详情</Link>
    //   ),
    // }),
  ];
  const [data, setData] = React.useState(() => [...defaultData]);
  const table = useReactTable({
    data,
    columns,
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getCoreRowModel: getCoreRowModel(),
    getSortedRowModel: getSortedRowModel(),
    debugTable: true,
  });
  const [pageNumber, setPageNumber] = React.useState(1);
  const [pageCount, setPageCount] = React.useState(1);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    setPageNumber(event.selected + 1)
  };

  React.useEffect(() => {
    commonFetch({
      url: '/api/balance/recharge/page',
      method: 'get',
      params: {
        pageNumber: pageNumber,
        pageSize: 10
      }
    }, toast).then(res => {
      setData(res.records)
      setPageCount(Math.ceil(res.total / 10))
    })
  }, [pageNumber])
  return (
    <Card
      flexDirection="column"
      w="100%"
      px="0px"
      overflowX={{ sm: 'scroll', lg: 'hidden' }}
    >
      {/* <Flex px="25px" mb="8px" justifyContent="space-between" align="center">
        <Text
          color={textColor}
          fontSize="22px"
          mb="4px"
          fontWeight="700"
          lineHeight="100%"
        >
          4-Columns Table
        </Text>
        <Menu />
      </Flex> */}
      {data.length ? (
        <Box>
          <Table variant="simple" color="gray.500" mb="24px" mt="12px">
            <Thead>
              {table.getHeaderGroups().map((headerGroup) => (
                <Tr key={headerGroup.id}>
                  {headerGroup.headers.map((header) => {
                    return (
                      <Th
                        key={header.id}
                        colSpan={header.colSpan}
                        pe="10px"
                        borderColor={borderColor}
                        cursor="pointer"
                        onClick={header.column.getToggleSortingHandler()}
                      >
                        <Flex
                          justifyContent="space-between"
                          align="center"
                          fontSize={{ sm: '10px', lg: '12px' }}
                          color="gray.400"
                        >
                          {flexRender(
                            header.column.columnDef.header,
                            header.getContext(),
                          )}
                          {{
                            asc: '',
                            desc: '',
                          }[header.column.getIsSorted()] ?? null}
                        </Flex>
                      </Th>
                    );
                  })}
                </Tr>
              ))}
            </Thead>
            <Tbody>
              {table
                .getRowModel()
                .rows.slice(0, 11)
                .map((row) => {
                  return (
                    <Tr key={row.id}>
                      {row.getVisibleCells().map((cell) => {
                        return (
                          <Td
                            key={cell.id}
                            fontSize={{ sm: '14px' }}
                            minW={{ sm: '150px', md: '200px', lg: 'auto' }}
                            borderColor="transparent"
                          >
                            {flexRender(
                              cell.column.columnDef.cell,
                              cell.getContext(),
                            )}
                          </Td>
                        );
                      })}
                    </Tr>
                  );
                })}
            </Tbody>
          </Table>
          <Flex mt="-20px" mr="30px" justifyContent={'flex-end'}>
            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
            />
          </Flex>
        </Box>
      ) : (
          <>
            <Table variant="simple" color="gray.500" mb="24px" mt="12px">
              <Thead>
                {table.getHeaderGroups().map((headerGroup) => (
                  <Tr key={headerGroup.id}>
                    {headerGroup.headers.map((header) => {
                      return (
                        <Th
                          key={header.id}
                          colSpan={header.colSpan}
                          pe="10px"
                          borderColor={borderColor}
                          cursor="pointer"
                          onClick={header.column.getToggleSortingHandler()}
                        >
                          <Flex
                            justifyContent="space-between"
                            align="center"
                            fontSize={{ sm: '10px', lg: '12px' }}
                            color="gray.400"
                          >
                            {flexRender(
                              header.column.columnDef.header,
                              header.getContext(),
                            )}
                            {{
                              asc: '',
                              desc: '',
                            }[header.column.getIsSorted()] ?? null}
                          </Flex>
                        </Th>
                      );
                    })}
                  </Tr>
                ))}
              </Thead>
            </Table>
            <Flex height={"200px"} justify={"center"} align={"center"}>
              <Text color={'gray.500'} fontSize={"18px"}>暂无数据</Text>
            </Flex>
          </>
      )}
    </Card>
  );
}
